import React from 'react';

import { Heading, Slide, Section, preloader } from 'spectacle-ppa';

import imagePPALogo from '../../images/ppa_presents.svg';
import imageZHLogo from '../../images/zeroHeroesNoPPAPresents.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './start.md';

import imgLevel1Start from '../../images/level-1_start.png';
import imgLevel2Start from '../../images/level-2_start.png';
import imgLevel3Start from '../../images/level-3_start.png';
import imgLevel4Start from '../../images/level-4_start.png';
import imgLevel5Start from '../../images/level-5_start.png';
import imgLevel6Start from '../../images/level-6_start.png';

const levels = {
  '1': { img: imgLevel1Start },
  '2': { img: imgLevel2Start },
  '3': { img: imgLevel3Start },
  '4': { img: imgLevel4Start },
  '5': { img: imgLevel5Start },
  '6': { img: imgLevel6Start }
};

const md = new MarkdownScript(markdownFile);

export function preloadStart () {
  preloader([
    imagePPALogo,
    imageZHLogo,
    imgLevel1Start,
    imgLevel2Start,
    imgLevel3Start,
    imgLevel4Start,
    imgLevel5Start,
    imgLevel6Start
  ]);
}

function startSection ({ level, title, regionData }) {
  /* Level intro graphic */
  return (
    <Section id="start">

      <Slide
          id="ppa-presents"
          key="ppa-presents"
          bgColor="black"
          notes={md.getSubSectionAsHtml(`Level ${level} Start`, 'Notes', false, regionData)}>
        <div
            className="ui-slide">
          <div className="flex-image">
            <img
                className="heading-image heading-image-before"
                src={imagePPALogo} />
          </div>
        </div>
      </Slide>

      <Slide
          id="ppa-zh"
          key="ppa-zh"
          bgColor="black"
          notes={md.getSubSectionAsHtml(`Level ${level} Start`, 'Notes', false, regionData)}>
        <div
            className="ui-slide">
          <div className="flex-image">
          <img className="zh-logo heading-image"
              src={imageZHLogo} />
          </div>
        </div>
      </Slide>

      {/* Sanksrit for Vanessa */}
      {/* lokah samastah sukhino bhavantu */}
      {/* may all beings everywhere be at peace */}

      <Slide
          id="level"
          key="level"
          bgColor="black"
          notes={md.getSubSectionAsHtml(`Level ${level} Icon`, 'Notes', false, regionData)}>
        <div
            className="ui-slide">
          <div className="title-image"><img
              className="heading-image heading-image-before"
              src={levels[level].img} />
            <Heading size={1}>
              <strong>{title}</strong>
            </Heading>
            <Heading size={2}>
              <strong>Level {level}</strong>
            </Heading>
          </div>
        </div>
      </Slide>

    </Section>
  );
}

export default startSection;



// WEBPACK FOOTER //
// ./programs/zeroHeroes/sections/01_start/startSection.jsx